import React from "react";
import { useTranslation } from "../i18n";

export default function LoadingSpinner({
  label = "Loading...",
  className = "",
  inline = false,
  size = "default",
}) {
  const { text } = useTranslation();
  const Wrapper = inline ? "span" : "div";
  const classes = [
    "loading-spinner-state",
    inline ? "loading-spinner-inline" : "",
    size === "small" ? "loading-spinner-small" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <Wrapper className={classes} role="status" aria-live="polite">
      <span className="loading-spinner-icon" aria-hidden="true" />
      {label && <span className="loading-spinner-label">{text(label)}</span>}
    </Wrapper>
  );
}
